import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class TripLogReportStore {
  loading = false;
  total = 0;
  tripLogReportData = [];
  tripData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      tripLogReportData: observable,
      tripData: observable,

      loadData: action,

      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    vehicleId,
    driverId,
    filterBy,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
    hasInvoice,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      driverId: driverId,
      filter: filterBy,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=triplogreport",
        "postData=" + base64Input
      );

    this.tripLogReportData = response?.data?.data?.triplogreport;

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async loadTripLogData({ vehicleId, fromDate, toDate, companyId }) {
    this.loading = true;
    var postData = {
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      companyId: companyId,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=getTripLogDetails",
        "postData=" + base64Input
      );

    this.tripData = response?.data?.data;

    this.loading = false;
  }

  async exportExcel(getData) {
    window.location.href =
      baseURL +
      "index.php?c=traxi_booking&a=exportTripLogexcel&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&filter=" +
      getData.filterBy +
      "&driverId=" +
      getData.driverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&userId=" +
      getData.userId +
      "&isadmin=" +
      getData.isadmin +
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {
    window.location.href =
      baseURL +
      "index.php?c=traxi_booking&a=exportTripLogPdf&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&filter=" +
      getData.filterBy +
      "&driverId=" +
      getData.driverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&userId=" +
      getData.userId +
      "&isadmin=" +
      getData.isadmin +
      "&colList=" +
      getData.colList;
  }
}

export default TripLogReportStore;
